import { observer } from 'mobx-react-lite';
import { Airplane } from '../../../../game/airplane';
import { DATA } from '../../../../game/data';
import { AIRPLANE_DATA, AIRPLANE_UPGRADES } from '../../../../game/data/airplaneData';
import { formatNumber } from '../../../../game/helpers';
import { GreenButton } from '../../Reusable/GreenButton';
import { AirplaneItem } from './AirplaneItem';
import { UpgradeInfoTable } from '../../UpgradeInfoTable';

export const AirplaneSidebar: React.FC = observer(() => {
  const renderUpgrade = () => {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16, marginBottom: 24 }}>
        {DATA.airplanes
          .slice()
          .sort((a, b) => a.id - b.id)
          .map((airplane) => (
            <AirplaneItem key={airplane.id} airplane={airplane} />
          ))}
      </div>
    );
  };

  const renderBuy = () => {
    if (DATA.airplanes.length >= AIRPLANE_DATA.MAX_AIRPLANES) {
      return <div className="max-amount">Max airplanes reached</div>;
    }

    // when calculating the price ignore the already spawned airplanes
    const price = AIRPLANE_DATA.priceFn(DATA.airplanes.length - AIRPLANE_DATA.DEFAULT_AIRPLANES);
    const canBuy = price <= DATA.money;

    const onBuyClick = () => {
      DATA.addMoney(-price);
      let biggestPriceStep = 0;
      if (DATA.airplanes.length > 0) {
        biggestPriceStep = DATA.airplanes.slice().sort((a, b) => b.priceStep - a.priceStep)[0].priceStep;
      }
      biggestPriceStep++;
      const airport = DATA.randomAvailableAirport();
      DATA.addAirplane(new Airplane(DATA.airplanes.length, `Airplane ${DATA.airplanes.length + 1}`, airport.slug, biggestPriceStep));
      DATA.save();
    };

    return (
      <GreenButton disabled={!canBuy} onClick={canBuy ? onBuyClick : undefined} style={{ width: '100%', marginBottom: 24 }}>
        <div>BUY AIRPLANE</div>${formatNumber(price)}
      </GreenButton>
    );
  };

  return (
    <>
      {renderUpgrade()}
      {renderBuy()}
      <div style={{ marginBottom: 8 }}>
        <UpgradeInfoTable upgrades={Object.values(AIRPLANE_UPGRADES)} />
      </div>
    </>
  );
});
